export default "__VITE_ASSET__DZrbw_n___"